import ActionCard from "./ActionCard/ActionCard";
import { useActionsData } from "../../../store/selectors/actionModulesSelectors";
import { useTableDataToRender } from "../../../hooks/UseTableDataToRender";
import { useEffect, useState } from "react";
import { ActionEdit } from "./ActionEdit";
import { Box, Dialog, Stack } from '@mui/material';
import { ActionModule } from "../../../types/actionModule/actionModule";
import { useAppDispatch } from "../../../hooks/StoreHooks";
import { fetchGroupsThunk } from "../../../store/thunk/groupsThunk";
import { useGroupsData } from "../../../store/selectors/groupSelectors";
import { PermissionEntityType } from "../../../types/permissionType";
import { usePermissionChecker } from "../../../hooks/usePermissionChecker";

const ActionCards = (props: { searchQuery: string }) => {
  const dispatch = useAppDispatch();
  const actionsData = useActionsData();
  const groupsList = useGroupsData();

  const [clickedActionCard, setClickedActionCard] = useState<ActionModule | undefined>(undefined)
  const tableDataToRender = useTableDataToRender(
    props.searchQuery,
    actionsData,
    "name"
  )

  const { userHasPermission } = usePermissionChecker();
  const canEditActionModule = (action: ActionModule) => {
    return userHasPermission(PermissionEntityType.ActionModules, "Edit") ||
      userHasPermission(PermissionEntityType.ActionModules, "Edit", action.id);
  };

  useEffect(() => {
    if (!groupsList.length) {
      dispatch(fetchGroupsThunk());
    }
  }, [dispatch, groupsList.length]);

  const handleEditClicked = (action: ActionModule) => {
    if (canEditActionModule(action)) {
      setClickedActionCard(action);
    }
  };

  return (
    <Stack direction="row" flexWrap="wrap">
      {tableDataToRender
        ? tableDataToRender.map((action: ActionModule) => (
          <Box key={action.id} sx={{ width: "33%" }}>
            <Box sx={{ p: 2 }}>
              <ActionCard
                actionItem={action}
                groupsList={groupsList}
                onEditClicked={() => handleEditClicked(action)}
              />
            </Box>
          </Box>
        ))
        : []}

      <Dialog
        open={!!clickedActionCard}
        onClose={() => setClickedActionCard(undefined)}
        fullWidth
        maxWidth="lg">
        {clickedActionCard && <ActionEdit
          actionItem={clickedActionCard}
          onSaved={() => setClickedActionCard(undefined)} />}
      </Dialog>
    </Stack>
  );
};

export default ActionCards;
